import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import styles from './Login.module.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useDispatch, useSelector } from "react-redux";
import {
    checkMSToken
} from './loginSlice'
import { useNavigate } from "react-router-dom";
import { validateEmail } from "../../app/utils/helpers"
import Langs from "../../app/lang/langs";
import logo from "../../assets/images/Logo-Groupe-Vital-Blanc-Baseline.png";
import { SignInButton } from '../../components/buttons/SignInButton';
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { loginRequest } from "../../app/utils/authConfig";
import { ThemeButton } from '../../components/buttons/ThemeButton';

export function LoginPage(props) {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const isAuthenticated = useIsAuthenticated()
    const isLoading = useSelector((state) => state.common.isLoading)
    const loginError = useSelector((state) => state.login.loginError)
    const formView = useSelector((state) => state.login.formView)
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [formError, setFormError] = useState('')
    const [collabsInput, setCollabsInput] = useState(false)
    const { instance, accounts, inProgress } = useMsal()


    useEffect(() => {
        if (isAuthenticated && !isLoading) {
            const request = {
                ...loginRequest,
                account: accounts[0]
            };
            instance.acquireTokenSilent(request).then((response) => {
                dispatch(checkMSToken(response))
            }).catch((e) => {
                instance.acquireTokenPopup(request).then((response) => {
                    dispatch(checkMSToken(response))
                })
            })
        }
    }, [isAuthenticated])

    

    function getLoginformView() {
        return <Row>
            <Row className="m-auto">
                <Col md={10} className="m-auto p-2 text-center">
                    <SignInButton />
                </Col>
            </Row>
            <Row className="m-auto">
                <Col md={10} className="m-auto p-2 text-center">
                </Col>
            </Row>
        </Row>
    }

    return <div>
        <Container fluid className={styles.fullHeight + " " + styles.background}>
            <Row className="d-flex justify-content-center align-items-top min-vh-100 text-center">
                <Col lg={4} className="p-4 text-left">
                    <img className={styles.logo} src={logo} alt={"logo"} />
                </Col>
                <Col lg={4} className={styles.loginContainer + " align-self-center"}>
                    <Row>
                        <Col md={12} className="m-auto p-4 text-center">
                            <span className={styles.welcomeText}>
                                <Langs str='WELCOME_TEXT' />
                            </span>
                        </Col>
                    </Row>
                    {getLoginformView()}
                </Col>
                <Col lg={4}>

                </Col>
            </Row>
        </Container>
    </div>
}